import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";

const useStyles = makeStyles(theme => ({
  contenedor: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    margin: theme.spacing(4),
    padding: theme.spacing(6),
    textAlign: "center"
  },
  icono: {
    fontSize: 48,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1)
  }
}));

/**
 * Pantalla para una ruta que el rol no alcanza.
 *
 * WHY una pantalla y no un redirect: redirigir obliga a elegir un destino, y
 * cualquier destino puede estar igual de vedado —con dos rutas protegidas que
 * se apunten entre sí sale un bucle infinito de redirecciones. Además, quien
 * llega aquí por un enlace compartido merece saber POR QUÉ no entra, no
 * aparecer sin explicación en otra página.
 */
const SinAcceso = ({ permiso }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.contenedor} elevation={0}>
      <LockOutlinedIcon className={classes.icono} />
      <Typography variant="h6">No tienes acceso a este módulo</Typography>
      <Typography variant="body2" color="textSecondary">
        Tu rol no incluye el permiso necesario para esta sección.
        Pídeselo a un administrador desde Roles y permisos.
      </Typography>
      {permiso && (
        <Typography variant="caption" color="textSecondary">
          Permiso requerido: <code>{permiso}</code>
        </Typography>
      )}
    </Paper>
  );
};

export default SinAcceso;
